import React, { useState } from "react";
import Reading from "../Reading/Reading";
import Speaking from "../Speaking/Speaking";
import Header from "../../components/Header/Header";
import Tab from "../../components/Tab/Tab";
import { tabProps } from "../../interfaces/Interface";
import Footer from "../../components/Footer/Footer";

const Home = () => {
  const [currentTab, setCurrentTab] = useState<number>(1);
  const onTabClick = (item: tabProps) => {
    setCurrentTab(item.id);
  };
  return (
    <main>
      <div className="p-6 bg-slate-100 border w-full shadow-lg min-h-screen">
        <Header heading="Speech Evaluation" />
        <Tab currentTab={currentTab} tabClick={onTabClick} />
        <div className="bg-white p-4 rounded-md mt-1 w-full shadow-l z-20">
          {currentTab === 1 && <Reading />}
          {currentTab === 2 && <Speaking />}
        </div>
      </div>
      <Footer />
    </main>
  );
};

export default Home;
